import { mod } from "./mod"

export const shortestAngle = (a, b) => {
  let r = a - b
  return mod(r + Math.PI, 2 * Math.PI) - Math.PI
}
